import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = ["src"];
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = { class: "desktop:hidden" };
import { I18nInfo } from '@/user/models';
import { clsx } from 'clsx';
import { SpriteIcons } from '@/user/components/common/';
import router from '@/user/router';
export default /*@__PURE__*/ _defineComponent({
    __name: 'HomeCertification',
    setup(__props) {
        const t = new I18nInfo('eduCenter.home.sectionCertification');
        const cards = [
            {
                img: '/images/renewal/certified_essentials.png',
                subtitle: t.translate('cert1.title'),
                description: t.translate('cert1.desc'),
                level: 'essentials',
            },
            {
                img: '/images/renewal/certified_associate.png',
                subtitle: t.translate('cert2.title'),
                description: t.translate('cert2.desc'),
                level: 'associate',
            },
            {
                img: '/images/renewal/certified_professional.png',
                subtitle: t.translate('cert3.title'),
                description: t.translate('cert3.desc'),
                level: 'professional',
            },
        ];
        const styles = {
            container: clsx('flex flex-col mt-24', 'desktop:gap-16 desktop:mt-32 desktop:border-t-1 border-gray-200 desktop:border-b-1 desktop:border-gray-200'),
            item: clsx('border-t-1 border-gray-200 py-20 first:border-t-0', 'desktop:py-32'),
            itemLink: clsx('group flex items-center gap-16', 'desktop:gap-40', 'cursor-pointer'),
            imageCover: clsx('shrink-0 w-110 h-104 px-17 py-14 bg-white rounded-8 flex items-center justify-center border-1 border-gray-250', 'desktop:w-200 desktop:h-120 desktop:border-0 desktop:p-0'),
            image: clsx('h-76', 'desktop:h-120'),
            infoBox: clsx('flex flex-col', 'desktop:flex-1 desktop:flex-row desktop:items-center desktop:justify-between desktop:gap-40'),
            title: clsx('text-m-title-1 desktop:text-title-1', 'group-hover:text-blue-700'),
            description: clsx('text-body-6 text-gray-800 mt-8 mb-16', 'desktop:text-body-4'),
            detailText: clsx('text-caption-1 flex items-center gap-4', 'text-gray-600 desktop:text-gray-400'),
            detailTextIcon: clsx('w-12 h-12 desktop:w-24 desktop:h-24', 'group-hover:text-blue-700'),
        };
        const handleCardClick = (level) => {
            router.push({
                name: 'CertificationInstruction',
                query: { level },
            });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("ul", {
                class: _normalizeClass(styles.container)
            }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(cards, (card, idx) => {
                    return _createElementVNode("li", {
                        key: idx,
                        class: _normalizeClass(styles.item)
                    }, [
                        _createElementVNode("div", {
                            class: _normalizeClass(styles.itemLink),
                            onClick: ($event) => (handleCardClick(card.level))
                        }, [
                            _createElementVNode("div", {
                                class: _normalizeClass(styles.imageCover)
                            }, [
                                _createElementVNode("img", {
                                    class: _normalizeClass(styles.image),
                                    src: card.img,
                                    alt: ""
                                }, null, 10, _hoisted_2)
                            ], 2),
                            _createElementVNode("div", {
                                class: _normalizeClass(styles.infoBox)
                            }, [
                                _createElementVNode("div", null, [
                                    _createElementVNode("strong", {
                                        class: _normalizeClass(styles.title)
                                    }, _toDisplayString(card.subtitle), 3),
                                    _createElementVNode("p", {
                                        class: _normalizeClass(styles.description),
                                        innerHTML: card.description
                                    }, null, 10, _hoisted_3)
                                ]),
                                _createElementVNode("span", {
                                    type: "button",
                                    class: _normalizeClass(styles.detailText)
                                }, [
                                    _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t).translate('detailLink')), 1),
                                    _createVNode(_unref(SpriteIcons), {
                                        name: "line-arrow-right",
                                        class: _normalizeClass(styles.detailTextIcon)
                                    }, null, 8, ["class"])
                                ], 2)
                            ], 2)
                        ], 10, _hoisted_1)
                    ], 2);
                }), 64))
            ], 2));
        };
    }
});
